import { useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { log } from "console";

const examples = [
  {
    id: 1,
    src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1743212252/ChatGPT_Image_Mar_28_2025_06_32_58_PM_ypo6hz.png",
    title: "Using it IRL ",
    description: "Capture your product being used in its natural environment. This helps others see how it fits into their life.",
  },
  {
    id: 2,
    src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1743211988/ChatGPT_Image_Mar_28_2025_06_27_36_PM_zjjbnb.png",
    title: "Natural lighting is key",
    description: "Take photos in well-lit areas, preferably with natural light. This brings out the best in your products!",
  },
  {
    id: 3,
    src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1743207987/ce1mul94ff2mnphykziv.png",
    title: "Show in your Lifestyle",
    description: "Include some context in your shots. Show how the product enhances your daily life!",
  },
];

interface ExampleCarouselProps {
  isOpen: boolean;
  onClose: () => void;
  onStartUpload: () => void;
}

export default function ExampleCarousel({ isOpen, onClose, onStartUpload }: ExampleCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  console.log("BALLER");

  const nextSlide = () => {
    if (currentIndex === examples.length - 1) {
      onStartUpload();
      onClose();
    } else {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const isLastSlide = currentIndex === examples.length - 1;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <div className="space-y-8 py-4">
          <div className="aspect-[4/3] relative overflow-hidden rounded-lg">
            <img
              src={examples[currentIndex].src}
              alt={examples[currentIndex].title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="space-y-4 text-center px-4">
            <h3 className="text-xl font-semibold">{examples[currentIndex].title}</h3>
            <p className="text-muted-foreground">{examples[currentIndex].description}</p>
          </div>

          <div className="flex items-center justify-between gap-4 pt-4">
            <Button
              variant="outline"
              onClick={prevSlide}
              disabled={currentIndex === 0}
              className="w-[100px]"
            >
              <ChevronLeft className="h-4 w-4 mr-2" />
              Back
            </Button>

            <Button onClick={nextSlide} className="w-[100px]">
              {isLastSlide ? "Let's Start!" : (
                <>
                  Next
                  <ChevronRight className="h-4 w-4 ml-2" />
                </>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
} 